<template>
  <UTabs
    :model-value="activeTab"
    :items="tabItems"
    :unmount-on-hide="true"
    color="primary-lighten-1"
    class="model-edit-form-person h-full min-h-0 items-stretch gap-0 overflow-hidden"
    :ui="{
      list: 'w-auto shrink-0 self-start gap-1 rounded-none bg-transparent p-0',
      indicator:
        'inset-y-0 rounded-b-none bg-primary-lighten-1 shadow-none dark:bg-primary-lighten-1-dark',
      trigger:
        'grow-0 rounded-b-none px-2 py-1 data-[state=active]:text-on-primary-lighten-1 dark:data-[state=active]:text-on-primary-lighten-1-dark',
      content: 'primary-lighten-1 min-h-0 flex-1 overflow-auto rounded-tl-none p-2'
    }"
    @update:model-value="onTabChange"
  >
    <template #general><ModelEditFormPersonGeneral /></template>
    <template #availability><ModelEditFormPersonAvailability /></template>
  </UTabs>
</template>

<script setup lang="ts">
import { inject, ref } from "vue"
import UTabs from "@nuxt/ui/components/Tabs.vue"
import ModelEditFormPersonGeneral from "@/components/model_edit_form/ModelEditFormPersonGeneral.vue"
import ModelEditFormPersonAvailability from "@/components/model_edit_form/ModelEditFormPersonAvailability.vue"
const tabItems = [
  { value: "general", label: "Algemeen", slot: "general" },
  { value: "availability", label: "Beschikbaarheid", slot: "availability" }
]
type ModelEditFormPersonTab = "general" | "availability"

const creationParameters = inject<{ initialTab?: ModelEditFormPersonTab } | undefined>(
  "creationParameters"
)
const activeTab = ref<ModelEditFormPersonTab>(creationParameters?.initialTab ?? "general")
function onTabChange(value: string | number) {
  if (value === "general" || value === "availability") activeTab.value = value
}
</script>

<style scoped></style>
